import Chart from 'react-apexcharts';
import './Graph.css';
import { ApexOptions } from 'apexcharts';

function ApexSeriesChart(props: any) {
  const optionsBar: ApexOptions = {
    //colors: props.colors,
    colors: props.colors,
    chart: {
      stacked: true,
      stackType: '100%',
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: '60%',
        borderRadius: 10,
      },
    },
    states: {
      hover: {
        filter: {
          type: 'none',
        },
      },
    },
    dataLabels: {
      enabled: props.enableDataLabel,
      style: {
        colors: ['#8B8296', '#8B8296', '#8B8296'],
      },
      offsetY: 100,
      formatter: function (val, opt) {
        if (props.hoursRecordedBins) {
          return opt.seriesIndex
            ? props.hoursRecordedBins[opt.seriesIndex - 1]
            : 'outage';
        }
        return opt.seriesIndex ? opt.seriesIndex : 'outage';
      },
    },
    stroke: {
      width: props.strokeWidth,
      colors: ['#fff'],
    },
    legend: {
      show: false,
    },
    grid: { show: false },
    xaxis: {
      labels: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        show: false,
      },
    },
    tooltip: { enabled: false },
  };
  const seriesBar = props.graphData;

  return (
    <div className="app">
      <div className="row">
        <div className="col percentage-chart">
          <Chart
            options={optionsBar}
            height={80}
            series={seriesBar}
            type="bar"
            width={props.graphWidth}
          />
        </div>
      </div>
    </div>
  );
}

export default ApexSeriesChart;
